export default __webpack_public_path__ + "static/media/28-SecludedCreek.b495d1f5.jpeg";